import {
  InquiryHistory,
  InquiryHistoryArgs,
  getInquiryHistory,
} from '../../assets/ts/data/inquiry/inquiry-history'
import useServerData from '../use-server-data'

function useInquiryHistory(fetchArgs , waitOnParentDependency = false) {
  const {
    data: inquiryHistory,
    error: inquiryHistoryError,
    fetchData: fetchInquiryHistory,
    isLoading: inquiryHistoryIsLoading,
  } = useServerData<InquiryHistory, InquiryHistoryArgs>(
    getInquiryHistory,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    fetchInquiryHistory,
    inquiryHistory,
    inquiryHistoryError,
    inquiryHistoryIsLoading,
  }
}

export default useInquiryHistory
